import axios from 'axios'
import qs from 'qs'
import { Toast,Indicator } from 'mint-ui'
import router from '@/router'
import storage from '@/utils/storage'
import token from '@/utils/token'
import config from '@/utils/config'


// axios.defaults.baseURL = 'http://api.ldnz.ydd100.cn:88/pjj-api/api'
axios.defaults.baseURL = 'http://jjb.api.oxygen-cc.com/pjj-api/api'
// axios.defaults.baseURL = 'http://112.80.30.150:8015/pjj/api/'


// 配置axios
let instance = axios.create({
  // baseURL: process.env.API_HOST,
  baseURL: '/api',
  timeout: 5000
})
instance.defaults.headers.post['Content-Type'] = 'application/json;charset-UTF-8'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'


// 请求拦截器
instance.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})


function buildURL (url, needToken) {
  var params='';

    if (!needToken) {
      // console.log(url + (url.indexOf('?') >= 0 ? "&" : "?")
      return url = url + (url.indexOf('?') >= 0 ? "&" : "?");
    }
    let token=''
    return url = url + (url.indexOf('?') >= 0 ? "&" : "?") + "token=" + token;
}


// POST 请求
export function fetchPost (url, params, needToken, multiple, needErr) {
  url = buildURL(url, needToken)
  // alert(url)
  if (!url) {
    return new Promise((resolve, reject) => {
      reject()
    })
  }
  if (multiple) {
    return new Promise((resolve, reject) => {
      console.log(params);
        axios.post(url, params, {
          headers: {
            'Content-Type': 'multiple/form-data'
          }
        }).then(response => {
          if (response.status == 200) {
            if (response.data.code == 0) {
              resolve(response.data)
            } else if (response.data.code == 4003) {
              reject(response)
            } else {
              if (response.data.code == 401) {
                storage.set('redirectUrl', router.history.current.fullPath);
                window.location.href = authUrl
                return;
              }
  
              reject(response)
              Toast({
                message: response.data.msg,
                position: 'bottom',
                duration: 2000
              });
              Indicator.close();
            }
          } else {
  
            reject(response)
            Toast({
              message: '服务器忙',
              position: 'bottom',
              duration: 2000
            });
            Indicator.close();
          }
        }).catch((error) => {
          reject(error)
          Toast({
            message: '请稍后再试哦',
            position: 'bottom',
            duration: 2000
          });
          Indicator.close();
        })
      }) 
    // })
  }
  return new Promise((resolve, reject) => {
    if (!needToken) {
      // console.log(url + (url.indexOf('?') >= 0 ? "&" : "?")
      return url = url + (url.indexOf('?') >= 0 ? "&" : "?");
    }
      console.log(params);
      console.log(qs.stringify(params));
      axios.post(url, qs.stringify(params)).then(response => {
        if (response.status === 200) {
          if (response.data.code === 0) {
            resolve(response.data)
          } else if (response.data.code === 4003) {
            reject(response)
          } else {
            if (response.data.code === 401) {
              // storage.set('redirectUrl', router.history.current.fullPath);
              // window.location.href = authUrl
              // return;
            }
            reject(response)
            if (!needErr) {
              Toast({
                message: response.data.msg,
                position: 'bottom',
                duration: 2000
              })
              Indicator.close();
            }
          }
        } else {
          reject(response)
          Toast({
            message: '服务器忙',
            position: 'bottom',
            duration: 2000
          })
          Indicator.close();
        }
      }).catch((error) => {
        reject(error)
        Toast({
          message: '请稍后再试哦',
          position: 'bottom',
          duration: 2000
        })
        Indicator.close();
      })
    }) 
    
  // })
}

// GET请求
export function fetchGet (url, params, needToken) {

  // url = buildURL(url, needToken)
  // alert(url)
  if (!url) {
    return new Promise((resolve, reject) => {
      reject()
    })
  }

  return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params
      }).then(response => {
        if (response.status === 200) {
          if (response.data.code === 0) {
            resolve(response.data)
          } else if (response.data.code === 4003) {
            reject(response)
          } else {
            if (response.data.code === 401) {
              // storage.set('redirectUrl', router.history.current.fullPath);
              // window.location.href = authUrl
              // return;
            }
            reject(response)
            Toast({
              message: response.data.msg,
              position: 'bottom',
              duration: 2000
            })
            Indicator.close();
          }
        } else {
          reject(response)
          Toast({
            message: '服务器忙',
            position: 'bottom',
            duration: 2000
          })
          Indicator.close();
        }
      }).catch((error) => {
        reject(error)
        Toast({
          message: '网络错误',
          position: 'bottom',
          duration: 2000
        })
        Indicator.close();
      })
    })
   
  // })
}
export default {
  ///用户协议
  agreements(params) {
    return fetchGet('/common/about_us', params, false)
  },
  // 学院
  college(params) {
    return fetchGet('/member/post/tutorial', params, false)
  },
  // 帖子详情
  postDetail(params) {
    return fetchGet('/member/post/detail', params, false)
  },
  // 分享签名
  gzhJsApiSign(params) {
    return fetchGet("/common/js/sign", params, false)
  }
};



// WEBPACK FOOTER //
// ./src/utils/apics.js